/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useContext as t,createContext as o}from"react";const r=o(void 0);function n(o){const n=t(r);return o||n||"ltr"}export{n as useDirection};
//# sourceMappingURL=index.js.map
